module.exports = __webpack_public_path__ + "img/list_number.6b87f5e1.svg";